const BusinessAddressTypes = Object.freeze({
  PREDEFINED_ADDRESS: 1,
  NEW_ADDRESS: 2,
});

export default BusinessAddressTypes;
